import React, { Component } from "react";
import { connect } from "react-redux";

// import classnames from "classnames";

import withStyles from "@material-ui/core/styles/withStyles";
import ActionReset from "@material-ui/icons/RestorePage";
import ActionDelete from "@material-ui/icons/Delete";

import {
  PageHeader,
  crudGetOne,
  FETCH_START,
  FETCH_END,
  SAVING_START,
  SAVING_END,
  showNotification,
  RestMethods,
  PageFooter,
  Button,
  BackButton
} from "jazasoft";

import OrderDetails from "../OrderDetails";
import handleError from "../../utils/handleError";
import { dataProvider } from "../../App";

const styles = {
  container: {
    margin: "1.5em",
    padding: 0
  }
};

class Reset extends Component {
  state = {
    rows: [],
    actualIds: [],
    plannedIds: [],
    layCompleted: false,
    deviationTypes: null
  };

  componentDidMount() {
    this.updateOrder();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      this.updateOrder();
    }
  }

  updateOrder = (id = this.props.id) => {
    if (id) {
      this.props.dispatch(crudGetOne("orders", id, this.props.basePath, this.props.requestConfig));
    }
  };

  onReset = () => {
    let options = {
      url: `orders/${this.props.id}/reset`,
      method: "post"
    };

    this.props.dispatch({ type: FETCH_START });
    this.props.dispatch({ type: SAVING_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        console.log(response.data);
        if (response.status === 200) {
          this.props.dispatch(showNotification("Order has been reset successfully."));
          this.updateOrder();
        }
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      });
  };

  onDelete = () => {
    let options = {
      url: `orders/${this.props.id}`,
      method: "delete",
      params: { action: "deep" }
    };

    this.props.dispatch({ type: FETCH_START });
    this.props.dispatch({ type: SAVING_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        if (response.status === 204 || response.status === 200) {
          this.props.dispatch(showNotification("Order along with fabric has been delete successfully."));
          this.props.history.push('/reset');
        }
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      });
  };

  render() {
    const { classes, order, id, saving } = this.props;

    return (
      <div className={classes.root}>
        <PageHeader title={`Reset Order #${id}`} />

        {order && Object.keys(order).length > 0 && (
          <div className={classes.container}>
            {/*Order Details */}
            <OrderDetails record={order} basePath="orders" resource="orders" />

            <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5em" }}>
              <Button style={{margin: "0 1em"}} label="Reset" variant="contained" color="primary" disabled={saving} onClick={this.onReset}>
                <ActionReset />
              </Button>
              <Button style={{margin: "0 1em"}} label="Delete" variant="contained" color="primary" disabled={saving} onClick={this.onDelete}>
                <ActionDelete />
              </Button>
            </div>

            <PageFooter>
              <BackButton style={{ marginRight: 8 }} variant="contained" />
            </PageFooter>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const resourceState = state.jazasoft.resources["orders"];
  const id = props.match.params.id;
  return {
    id,
    order: resourceState && resourceState.data && resourceState.data[id],
    isLoading: state.jazasoft.loading > 0,
    saving: state.jazasoft.saving,
    version: state.jazasoft.ui.viewVersion
  };
};

export default connect(mapStateToProps)(withStyles(styles)(Reset));
